const initialState = {
    multiOrderCode: [],
    receiveCodeAlt: [],
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'MULTI_ORDER_CODE_PATTERN_SETTINGS_SUCCESS') {
        return {
            ...state,
            multiOrderCode: action.payload,
        };
    }

    if (action.type === 'RECEIVE_CODE_ALT_PATTERN_SETTINGS_SUCCESS') {
        return {
            ...state,
            receiveCodeAlt: action.payload,
        };
    }

    return state;
}

export default reducer;
